// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"ix_a bhu_je","CommentListPlaceholder--Legacy":"ix_b bhu_qh bhu_vk"};